/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Commission_Note_BoldInputs */

const es_ab_commission_note_bold = /** @type {(inputs: Ab_Commission_Note_BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`más baja`)
};

const gl_ab_commission_note_bold = /** @type {(inputs: Ab_Commission_Note_BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`máis baixa`)
};

const en_ab_commission_note_bold = /** @type {(inputs: Ab_Commission_Note_BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lowest commission`)
};

/**
* | output |
* | --- |
* | "lowest commission" |
*
* @param {Ab_Commission_Note_BoldInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_commission_note_bold = /** @type {((inputs?: Ab_Commission_Note_BoldInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Commission_Note_BoldInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_commission_note_bold(inputs)
	if (locale === "en") return en_ab_commission_note_bold(inputs)
	return es_ab_commission_note_bold(inputs)
});